import { render, staticRenderFns } from "./paypalMethod.vue?vue&type=template&id=247d7200&"
import script from "./paypalMethod.vue?vue&type=script&lang=js&"
export * from "./paypalMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "paypalMethod.vue"
export default component.exports